module.exports = __webpack_public_path__ + "c5a1cdc7f872e764e647a8764c8b0660.pdf";